// TODO: This component is probably no longer necessary but need to replace it's uses
import { JSX } from 'react';
export const PartCircleIcon = ({ fill }: { fill?: string }): JSX.Element => {
  const color = fill || '#D8D7FF';
  return (
    <svg
      width="57"
      height="16"
      viewBox="0 0 57 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      role="img"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0301 5.78913C19.4377 5.78913 11.1972 9.08207 5.12119 14.9438C3.94954 16.0742 2.05005 16.074 0.878547 14.9436C-0.292954 13.8131 -0.292834 11.9804 0.878815 10.85C8.0801 3.90272 17.8466 0 28.0301 0C38.2135 0 47.98 3.90272 55.1812 10.85C56.3529 11.9804 56.353 13.8131 55.1815 14.9436C54.01 16.074 52.1105 16.0742 50.9389 14.9438C44.8628 9.08207 36.6224 5.78913 28.0301 5.78913Z"
        fill={color}
      />
    </svg>
  );
};
